// 生 ChakraBadge を import できるのは lint の許可リスト (@ebalance/eslint-config の
// react-app.cjs) に載ったユーザー定義タグ色 / カテゴリカル専用部品だけ。 本ファイルはその 1 つ。
import { useTranslation } from 'react-i18next'

import {
  ChakraBadge,
  LightModeSemanticColors,
} from '@enechain/ecloud-designsystem'

import { localizeBuiltinWorkflowText } from '~/models/workflowBuiltinText'
import { getWorkflowCaseTagColorStyle } from '~/models/workflowCaseTag'

type Props = {
  label: string
  color: string
}

/**
 * ワークフローケース / 雛形のタグ 1 件を色付きチップとして表示する (AC-01, design
 * `.case-tag` 相当)。
 *
 * 角丸は `full` (pill)。 design `.case-tag` (cases.html:69) が `--radius-full` で、
 * **ステータス Badge (角丸小) と字面で区別する**ための意図的な差 (2026-08-17 デザイナー
 * 指摘「他の Badge とかぶらないように、8080 では radius で資格さを付与している」)。
 *
 * 色はユーザーがタグに設定した識別色であって業務状態ではないため、 semantic status
 * ではなく design/css/tokens.css の `--tag-*` パレットを tag.color から解決する
 * (#4544)。 ecloud token に tag 専用パレットが無いため、 style attr で直接適用する。
 */
export const WorkflowCaseTagChip = ({
  label,
  color,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const displayLabel = localizeBuiltinWorkflowText(label, t)
  const style = getWorkflowCaseTagColorStyle(
    color,
    LightModeSemanticColors.Surface.primary.value,
    LightModeSemanticColors.Text.highEmphasis.value,
  )
  if (style === undefined) {
    return (
      <ChakraBadge borderRadius="full" colorPalette="gray" variant="subtle">
        {displayLabel}
      </ChakraBadge>
    )
  }
  return (
    <ChakraBadge borderRadius="full" style={style} variant="subtle">
      {displayLabel}
    </ChakraBadge>
  )
}
